export default __webpack_public_path__ + "static/media/001m.73150c37.png";